<template>
  <div class="tabCont" v-if="breadcrumbList instanceof Array && breadcrumbList.length > 0  || statusList instanceof Array && statusList.length > 0">
    <el-breadcrumb v-if="breadcrumbList instanceof Array && breadcrumbList.length > 0" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item v-for="item in breadcrumbList" :key="item">{{ item }}</el-breadcrumb-item>
    </el-breadcrumb>
    <template v-if="statusList instanceof Array && statusList.length > 0">
        <el-tabs v-model="status"
                @tab-click="refreshTable"
                ref="tabs"
                type="card">
        <el-tab-pane 
                    v-for="item in statusList"
                    :key="item.status"
                    :name="item.status">
                    <div slot="label">
                        <span v-if="item.name === 'Abnormal' && item.total > 0">
                            {{item.name}} <i style="color:red; font-style: normal;">({{item.total}})</i>
                        </span>
                        <span v-else>
                            {{item.name}} ({{(item.total || 0)}})
                        </span>
                    </div>
        </el-tab-pane>
        </el-tabs>
    </template>
  </div>
</template>
<script>
export default {
    data() {
        return {
            breadcrumbList: (() => {
                const title = document.title.split(' - ')
                title.shift()
                
                return title[0] === 'System' && title || []
            })()
        }
    },
    props: {
        status: String,
        statusList: Array,
        funcName: String,
    },
    methods: {
        refreshTable() {
            this.$emit("update:status", this.status);
            if (this.$parent[this.funcName]) {
                this.$parent[this.funcName](1);
            } else if (this.$parent.$parent[this.funcName]) {
                this.$parent.$parent[this.funcName](1);
            }
        },
    },
};
</script>
<style lang="scss">
.tabCont {
    .el-breadcrumb {
        margin-bottom: 16px;

        .el-breadcrumb__item {
            .el-breadcrumb__inner {
                font-size: 14px;
            }

            &:last-child {
                .el-breadcrumb__inner {
                    color: #635cff;
                }
            }
        }
    }
    .el-tabs__item:focus.is-active.is-focus:not(:active) {
        -webkit-box-shadow: none;
        box-shadow: none;
    }
    .el-tabs__nav {
        z-index: 1 !important;
        border-radius: 0 !important;
        height: 36px;
        border-top: 0 !important;
    }
    .el-tabs__item {
        height: 34px;
        line-height: 34px;
        font-size: 12px;
        background: #fafafa;
        border-top: 1px solid #e4e7ed;
        font-weight: 400 !important;
    }
    .el-tabs__item.is-active {
        height: 36px;
        background: #fff;
        box-sizing: border-box;
        border-top: 2px solid $color-primary;
        border-radius: none !important;
    }
}
</style>